import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';


@Pipe({name: 'timeConverter'})
export class TimeConveterPipe implements PipeTransform {

    timezone = localStorage.getItem('timezone');

    transform(value: number, format: string) {

        return new DatePipe('en-US').transform((value * 1000), format, this.timezone);

    }
}